// formatLastSeen.js
export default function formatLastSeen(lastActive) {
    if (!lastActive || !lastActive.toDate) return "N/A";
  
    const last = lastActive.toDate();
    const now = new Date();
    const diffMs = now - last;
    const diffMins = Math.floor(diffMs / 60000);
  
    if (diffMins < 1) return "Last seen just now";
    if (diffMins === 1) return "Last seen 1 minute ago";
    if (diffMins < 60) return `Last seen ${diffMins} minutes ago`;
  
    const diffHours = Math.floor(diffMins / 60);
    if (diffHours === 1) return "Last seen 1 hour ago";
    if (diffHours < 24) return `Last seen ${diffHours} hours ago`;
  
    return `Last seen on ${last.toLocaleDateString()}, ${last.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
    })}`;
  }
  